export default "__VITE_ASSET__63bf1ba3__"